// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-term hr {
    margin-top: 10px;
}

.delete-term-btn button {
    margin-left: 5px;
}

button .fa-plus, .fa-minus {
    color: #fff;
    margin: 0px 5px 0px 0px;
}
.term-container {
    width: 100%;
}

.term-text-amount-container {
    display: flex !important;
    justify-content: left !important;
}

.label-date {
    margin-bottom: 0px !important;
}

.form-check-input {
    cursor: pointer;
}

.term-hind {
    color: gray;
}`, "",{"version":3,"sources":["webpack://./src/components/SetCourseTerm/SetCourseTerm.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;AACA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".add-term hr {\n    margin-top: 10px;\n}\n\n.delete-term-btn button {\n    margin-left: 5px;\n}\n\nbutton .fa-plus, .fa-minus {\n    color: #fff;\n    margin: 0px 5px 0px 0px;\n}\n.term-container {\n    width: 100%;\n}\n\n.term-text-amount-container {\n    display: flex !important;\n    justify-content: left !important;\n}\n\n.label-date {\n    margin-bottom: 0px !important;\n}\n\n.form-check-input {\n    cursor: pointer;\n}\n\n.term-hind {\n    color: gray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
